import { render, staticRenderFns } from "./WorkerFeedback.vue?vue&type=template&id=bd1955fc&"
import script from "./WorkerFeedback.vue?vue&type=script&lang=js&"
export * from "./WorkerFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports